// t() for the store dashboards, over the CMS TextBundle "store_dashboards".
//
// The dashboards are a framework component any app shows, in the page's
// language: their words are a TextBundle (aldoo-ra/CMS/text-bundle, which
// follows the site's language), loaded where a dashboard is open. The code
// writes English — t`Customize`, t("%s cards", n), t(metric.label) — and the
// English finds its key in ./texts-en.js: the bundle's translation when it has
// one, the English itself until it has loaded or when it has no such text.
// Labels the api answers (metrics, groups, filters) go through t() the same
// way, so they are translated when the bundle knows them.
import { useMemo } from "react"
import TextBundle from "aldoo-ra/CMS/text-bundle"
import TEXTS from "./texts-en"

export const BUNDLE_ID = "store_dashboards"

// English → key
const byEnglish = new Map(Object.entries(TEXTS).map(([key, english]) => [english, key]))

const format = (text, args) => {
  if (!args.length) return text
  let i = 0
  return text.replace(/%s/g, () => (i < args.length ? String(args[i++]) : "%s"))
}

export default function useDashboardTexts() {
  const loaded = TextBundle({ id: BUNDLE_ID })
  return useMemo(
    () =>
      (text, ...args) => {
        // tagged template: t`English`
        if (Array.isArray(text)) {
          if (text.length > 1) throw new Error("Cannot use t with a template that has ${...}")
          text = text[0]
        }
        if (text === undefined || text === null) return ""
        const key = Object.prototype.hasOwnProperty.call(TEXTS, text) ? text : byEnglish.get(text)
        const translated = key !== undefined ? loaded?.[key] : undefined
        return format(typeof translated === "string" && translated ? translated : key !== undefined ? TEXTS[key] : String(text), args)
      },
    [loaded]
  )
}
